Backbone = require 'backbone'

class FAQHomeModel extends Backbone.Model
  initialize: ->
    @url = "#{window.FAQBASEURL}/home?should_display_cms_content=#{experiments.shouldDisplayCMSContentForUS}"

module.exports = FAQHomeModel
